<!-- No firing log found state -->
<div *ngIf="!gotFilename" class="no-log-container">
  <div class="no-log-card">
    <div class="no-log-icon">
      <ion-icon name="document-outline"></ion-icon>
    </div>
    <h3 class="no-log-title">{{ 'FIRING_LOG.NO_FIRING_LOG_AVAILABLE' | translate }}</h3>
    <p class="no-log-description">
      {{ 'FIRING_LOG.NO_FIRING_LOGS_YET' | translate }}
    </p>
    <div class="no-log-info">
      <ion-icon name="information-circle-outline"></ion-icon>
      <span>{{ 'FIRING_LOG.UPLOAD_INSTRUCTIONS' | translate }}</span>
    </div>
  </div>
</div>

<!-- Firing log found state -->
<div *ngIf="gotFilename" class="log-container">
  <div class="log-card">
    <div class="log-header">
      <div class="log-icon">
        <ion-icon name="document-text-outline" color="light"></ion-icon>
      </div>
      <div class="log-info">
        <h3 class="log-title">{{ 'FIRING_LOG.LATEST_FIRING_LOG' | translate }}</h3>
        <!-- <p class="log-filename">{{logFile.firingNumber}}</p> -->
      </div>
    </div>
    <div class="log-actions">
      <ion-button 
        fill="solid" 
        color="primary" 
        size="medium" 
        (click)="download()"
        class="download-button">
        <ion-icon name="download-outline" slot="start"></ion-icon>
        {{ 'FIRING_LOG.DOWNLOAD_LOG' | translate }}
      </ion-button>
    </div>
  </div>
  
  <!-- Additional firing logs -->
  <div *ngIf="allLogFiles.length > 0" class="additional-logs-section">
    <h4 class="additional-logs-title">{{ 'FIRING_LOG.ADDITIONAL_LOGS' | translate }}</h4>
    <ion-list class="additional-logs-list">
      <ion-item *ngFor="let logFile of allLogFiles" class="additional-log-item" button (click)="downloadLog(logFile)">
        <ion-icon name="document-text-outline" slot="start" color="primary"></ion-icon>
        <ion-label>
          <h3>Firing #{{ logFile.firingNumber || 'N/A' }}</h3>
          <p *ngIf="logFile.date" class="log-date">{{ logFile.date }}</p>
        </ion-label>
        <ion-icon name="download-outline" slot="end" color="primary"></ion-icon>
      </ion-item>
    </ion-list>
  </div>
  
</div>